import React, { useState, useEffect } from 'react';
import { RichUtils } from 'draft-js';
import { ToolbarButton } from './ToolbarButton';
import { useToolbarContext } from './TextEditorToolbar';

export const ToolbarInlineStyleButton = ({ inlineStyle, icon, title, ...rest }) => {
  const { getEditorState, setEditorState } = useToolbarContext();
  const [active, setActive] = useState(false);

  // eslint-disable-next-line
  useEffect(() => {
    const hasInlineStyle = getEditorState()
      .getCurrentInlineStyle()
      .has(inlineStyle);
    hasInlineStyle && !active && setActive(true);
    !hasInlineStyle && active && setActive(false);
  });

  const toggle = e => {
    e.preventDefault();
    const newState = RichUtils.toggleInlineStyle(getEditorState(), inlineStyle);
    newState && setEditorState(newState);
    setActive(!active);
  };

  return (
    <ToolbarButton
      onClick={toggle}
      active={active}
      title={title}
      onMouseDown={e => e.preventDefault()}
      {...rest}
    >
      {icon}
    </ToolbarButton>
  );
};
